class EventToProductIdsTransformer {
  transform (event) {
    let discountedProductIds = event.discountedProducts.map(product => product.id)
    let promotedProductIds = event.specialPromotions.reduce((result, promotion) => {
      if (promotion.rewards.awardedProducts) {
        result = result.concat(promotion.rewards.awardedProducts.map(product => product.productId))
      }

      if (promotion.requirements.purchasedProducts) {
        result = result.concat(promotion.requirements.purchasedProducts.map(product => product.productId))
      }

      return result
    }, [])

    return discountedProductIds.concat(promotedProductIds)
  }
}
export default EventToProductIdsTransformer



// WEBPACK FOOTER //
// ./src/transformers/EventToProductIdsTransformer.js